import Vue from 'vue'
//import VTooltip from 'v-tooltip'
import { VTooltip, VPopover, VClosePopover } from 'v-tooltip'
import App from './App.vue'

Vue.directive('tooltip', VTooltip)
Vue.directive('close-popover', VClosePopover)
Vue.component('v-popover', VPopover)

//Vue.use(VTooltip)

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
